import { useT } from '../i18n/context'

/**
 * Kennzeichnet den Beta-Betrieb (Analogon zum BetaBadge des Nuxt-Frontends):
 * Die Plattform ist öffentlich erreichbar, aber noch nicht für den
 * produktiven Einsatz freigegeben. Sobald Launch-Ready erreicht ist,
 * wieder entfernen.
 */
export function BetaBadge() {
    const t = useT()
    return (
        <span className='inline-flex shrink-0 items-center rounded-full bg-amber-100 dark:bg-amber-900/60 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-700 dark:text-amber-300'>
            {t('common.beta')}
        </span>
    )
}
